var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDownload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8C9EA7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.72 12.705l-.97.905V9.7c0-.386-.335-.7-.75-.7s-.75.314-.75.7v3.91l-.97-.905a.787.787 0 0 0-1.06 0 .667.667 0 0 0 0 .99l2.249 2.1a.804.804 0 0 0 .817.152.749.749 0 0 0 .245-.153l2.25-2.1a.667.667 0 0 0 0-.989.787.787 0 0 0-1.061 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.707 5.1C15.365 2.67 13.002 0 10.161 0 8.638 0 7.089.704 6.055 1.835a3.192 3.192 0 0 0-1.038-.173c-1.616 0-2.941 1.199-3.022 2.702C.801 5.088 0 6.426 0 7.764c0 .84.295 1.77.81 2.552C1.494 11.355 2.746 12 4.078 12h.56c.11-.294.282-.565.522-.791.425-.4.99-.62 1.591-.62V9.175C6.75 8.01 7.759 7.06 9 7.06c1.24 0 2.25.95 2.25 2.117v1.412c.6 0 1.165.22 1.59.62.242.227.412.498.523.792h.786c1.946 0 3.627-1.364 3.826-3.105.017-.14.025-.281.025-.424 0-1.621-.882-2.89-2.293-3.372z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download.d2494e09.svg";
export { ForwardRef as ReactComponent };